import { ScheduleEntry } from "../models/ScheduleEntry.js";
import { ViewModel } from "../mvvm/ViewModel.js";
/** Staff weekly calendar rows with accept / decline / cancel that patch in place. */
export class StaffScheduleViewModel extends ViewModel {
    client;
    siteSlug;
    constructor(client, siteSlug) {
        super({ entries: [], loading: false, error: null });
        this.client = client;
        this.siteSlug = siteSlug;
    }
    /** Seed rows without hitting the API (previews, tests). */
    seed(entries) {
        this.setState({ entries, loading: false, error: null });
    }
    async load() {
        this.setState({ loading: true, error: null });
        try {
            const list = await this.client.listAppointmentsStaff();
            const listings = new Map((await this.client.listListings(this.siteSlug)).map((l) => [l.id, l]));
            this.setState({
                entries: list.map((a) => ScheduleEntry.fromAppointment(a, listings)),
                loading: false,
            });
        }
        catch {
            this.setState({ loading: false, error: "Appointment calendar API is not available yet." });
        }
    }
    accept(id) {
        return this.transition(id, "accepted", () => this.client.acceptAppointment(id), "Could not accept appointment.");
    }
    decline(id) {
        return this.transition(id, "declined", () => this.client.declineAppointment(id), "Could not decline appointment.");
    }
    cancel(id) {
        return this.transition(id, "cancelled", () => this.client.cancelAppointment(id), "Could not cancel appointment.");
    }
    async transition(id, status, call, failure) {
        this.setState({ error: null });
        try {
            await call();
        }
        catch {
            this.setState({ error: failure });
            return false;
        }
        this.setState({
            entries: this.state.entries.map((e) => (e.id === id ? e.withStatus(status) : e)),
        });
        return true;
    }
}
//# sourceMappingURL=StaffScheduleViewModel.js.map